module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_toerbel-6485e07c988b2596d8253559f0d8d145.png";